// import { useState } from "react";
// const LocInput = () => {
//     const [query, setQuery] = useState("");
//     const [results, setResults] = useState([]);

//     const searchLocation = async (value) => {
//         setQuery(value);
//         if (value.length < 3) return;

//         const res = await fetch(
//             `https://nominatim.openstreetmap.org/search?format=json&q=${value}`
//         );
//         const data = await res.json();
//         setResults(data);
//     };

//     const selectLocation = (place) => {
//         console.log("Latitude:", place.lat);
//         console.log("Longitude:", place.lon);
//         setQuery(place.display_name);
//         setResults([]);
//     };

//     return (
//         <div style={{ width: "300px" }}>
//             <input
//                 type="text"
//                 value={query}
//                 onChange={(e) => searchLocation(e.target.value)}
//                 placeholder="Search location"
//                 style={{ width: "100%", padding: "8px" }}
//             />

//             <ul style={{ listStyle: "none", padding: 0 }}>
//                 {results.map((place) => (
//                     <li
//                         key={place.place_id}
//                         onClick={() => selectLocation(place)}
//                         style={{
//                             cursor: "pointer",
//                             padding: "6px",
//                             borderBottom: "1px solid #ccc"
//                         }}
//                     >
//                         {place.display_name}
//                     </li>
//                 ))}
//             </ul>
//         </div>
//     );
// }
// export default LocInput


import { useEffect, useState, useRef } from "react";

const DEFAULT_LOCATION = {
    display_name: "Kochi, Kerala, India",
    lat: "9.9312",
    lon: "76.2673",
};

const LocInput = ({ defaultLocation = DEFAULT_LOCATION, onChange, errors, name, label }) => {
    const [query, setQuery] = useState(defaultLocation.display_name);
    const [results, setResults] = useState([]);
    const [place, setPlace] = useState({});
    const [activeIndex, setActiveIndex] = useState(-1);

    const debounceRef = useRef(null);
    const cacheRef = useRef({});
    const abortRef = useRef(null);
    const lastQueryRef = useRef("");
    useEffect(() => {
        if (!defaultLocation?.display_name) return;
        onChange(defaultLocation);
    }, [defaultLocation]);
    // 🔍 Search


    // const searchLocation = async (value) => {
    //     // const delay = Date.now() - keyDownTime;
    //     // keyDownTime = Date.now();

    //     setQuery(value);

    //     if (value.length < 3) {
    //         setResults([]);
    //         return;
    //     }
    //     try {
    //         const res = await fetch(
    //             `https://nominatim.openstreetmap.org/search?format=json&q=${value}`
    //         );
    //         const data = await res.json();
    //         setResults(data);
    //     } catch (error) {
    //     }
    //     setActiveIndex(-1);
    // };



    const searchLocation = (value) => {
        setQuery(value);
        clearTimeout(debounceRef.current);
        setPlace({});

        if (value.length < 3 || value === lastQueryRef.current) return;

        debounceRef.current = setTimeout(async () => {
            lastQueryRef.current = value;

            if (cacheRef.current[value]) {
                setResults(cacheRef.current[value]);
                return;
            }

            if (abortRef.current) {
                abortRef.current.abort();
            }

            abortRef.current = new AbortController();

            try {
                const res = await fetch(
                    `https://nominatim.openstreetmap.org/search?format=json&q=${value}&limit=5`,
                    {
                        signal: abortRef.current.signal,
                        headers: {
                            "User-Agent": "my-app (contact@myapp.com)",
                        },
                    }
                );
                const data = await res.json();
                cacheRef.current[value] = data;
                setResults(data);
                setActiveIndex(-1);
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error(err);
                }
            }
        }, 500);
    };


    // 📍 Select
    const selectLocation = (place) => {
        console.log("Latitude:", place.lat);
        console.log("Longitude:", place.lon);
        onChange(place);
        setPlace(place);

        setQuery(place.display_name);
        setResults([]);
        setActiveIndex(-1);
    };

    // ⌨ Keyboard navigation
    const handleKeyDown = (e) => {
        if (!results.length) return;

        if (e.key === "ArrowDown") {
            setActiveIndex((prev) =>
                Math.min(prev + 1, results.length - 1)
            );
        }

        if (e.key === "ArrowUp") {
            setActiveIndex((prev) =>
                Math.max(prev - 1, 0)
            );
        }

        if (e.key === "Enter" && activeIndex >= 0) {
            selectLocation(results[activeIndex]);
        }
    };

    // Log default lat/lng on mount (optional)
    useEffect(() => {
        console.log("Default Lat:", DEFAULT_LOCATION.lat);
        console.log("Default Lng:", DEFAULT_LOCATION.lon);
    }, []);

    return (
        <div style={{ position: "relative" }}>
            <label className="text" htmlFor="location">{label}</label>
            <input

                type="text"
                value={query}
                onChange={(e) => searchLocation(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Search location"
                style={{ width: "100%", padding: "8px" }}
                onBlur={(e) => onChange(place)}

            />
            {errors?.[name] && (
                <span style={{ color: "red" }}>
                    {errors?.[name].message}
                </span>
            )}

            {results.length > 0 && (
                <ul
                    style={{
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                        border: "1px solid #ccc",
                        maxHeight: 200,
                        overflowY: "auto",
                    }}
                >
                    {results.map((place, index) => (
                        <li
                            key={place.place_id}
                            onClick={() => selectLocation(place)}
                            style={{
                                cursor: "pointer",
                                padding: "6px",
                                background:
                                    index === activeIndex ? "#eee" : "#fff",
                                borderBottom: "1px solid #ddd",
                            }}
                        >
                            {place.display_name}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default LocInput;

